import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatExcerpt } from "src/lib/formatters";

interface ReadMoreProps {
	text: string;
	length?: number;
	button_labels?: {
		open?: string;
		closed?: string;
	};
	defaultOpen?: boolean;
	className?: string;
}

const ReadMore = ({
	text,
	length,
	button_labels,
	defaultOpen,
	className,
}: ReadMoreProps) => {
	const { t } = useTranslation(["buttons"]);
	const excerpt = formatExcerpt(text, length || 20);
	const [visible, setVisible] = useState(defaultOpen || false);

	const getButtonLabel = () => {
		if (visible) {
			return button_labels?.open || t("read-less");
		}
		return button_labels?.closed || t("read-more");
	};

	return (
		<p className={`${className || ""} description`}>
			{visible ? text : excerpt}
			{text?.length !== excerpt?.length && (
				<strong
					onClick={() => setVisible(!visible)}
					className="block cursor-pointer transition-all opacity-40 hover:opacity-100"
				>
					{getButtonLabel()}
				</strong>
			)}
		</p>
	);
};

export default ReadMore;
